// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-msg[data-v-44e0c10e]{text-align:center;padding:2rem 0}.loading-msg .spinner[data-v-44e0c10e]{color:#9b9b9b;width:40px;height:40px;margin-right:12px}.loading-msg .message[data-v-44e0c10e]{color:#333;font-size:1.5rem;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
